import styled from 'styled-components';

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 40px;

  & .title {
    text-align: justify;
    font-weight: 600;
  }
`;
export const ModalChildern = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;
